// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpCircleFilledSvg from "@ant-design/icons-svg/es/asn/UpCircleFilled";
import AntdIcon from '../components/AntdIcon';

var UpCircleFilled = function UpCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleFilledSvg
  }));
};

UpCircleFilled.displayName = 'UpCircleFilled';
export default React.forwardRef(UpCircleFilled);